exports.PRINTER_TYPE = {
  LASER: 0,
  ELTRON: 1,
  CITIZEN: 2,
  ZEBRA: 3,
};

exports.PRINTER_DRIVER_TYPE = {
  NONE: 0,
  MYDPD_SERVICE: 1,
  WEB_USB: 2,
};

exports.PRINTER_USB_VENDOR_ID = {
  TSC: 4611, // 0x1203
  ZEBRA: 2655, // 0x0a5f
  CITIZEN: 7568, // 0x1D90
  CITIZEN_CL521: 2237, // 0x08BD
};
